import { ChangeDetectionStrategy, Component, OnChanges, OnInit } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { AgrExtendedNotificationModule } from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';

@Component({
  selector: 'app-customer-blocked-notification',
  templateUrl: './customer-blocked-notification.html',
  imports: [AgrI18nSharedModule, AgrExtendedNotificationModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerBlockedNotificationComponent implements OnInit, OnChanges {
  emptyDescription: string;
  private isAtLeastAdvisor: boolean;
  private isAtLeastAdvisor$ = this.store.select(AuthorizationSelectors.hasAtLeastAdvisorRole);

  constructor(private readonly store: Store<RootState>) {}

  ngOnInit(): void {
    this.isAtLeastAdvisor$.pipe(take(1)).subscribe((isAtLeastAdvisor) => {
      this.isAtLeastAdvisor = isAtLeastAdvisor;
      this.updateEmptySuffixes();
    });
  }

  ngOnChanges(): void {
    this.updateEmptySuffixes();
  }

  private updateEmptySuffixes(): void {
    this.emptyDescription = `blocked-${this.isAtLeastAdvisor ? 'advisor-or-higher' : 'customer'}-description`;
  }
}
